import React from "react";
import { connect } from "react-redux";
import { Outlet } from "react-router-dom";
import { compose } from "redux";
import {
  withRouter,
  AccountType,
  withAccessControl,
  SMART_BANNER_CONTAINER_ID,
  UniversalAppShell,
  RouterProps,
} from "component-library";
import { useSupportChat } from "shared-hooks";
import { IUser } from "shared/models/user";
import { MapDispatchToProps } from "shared/types/utilities";
import { IApplicationState } from "store";
import { getCommonTranslation } from "store/translation/translation.actions";
import { GetCommonTranslation } from "store/translation/translation.types";
import { hidePopup, setLoading, setLocale } from "store/ui/ui.actions";
import { HidePopup, IUIState, SetLoading, SetLocale } from "store/ui/ui.types";

import { getUserData } from "store/user/user.actions";

import withUserData, {
  IWithUserActions,
  IWithUserStoreProps,
} from "hoc/withUserData";
import withGlobalSpinner from "hoc/withGlobalSpinner";
import withLocalizedData from "hoc/withLocalizedData";

import Popups from "components/Popups/Popups";
import config from "config/global";

export interface IAppActions extends IWithUserActions {
  setLoading: SetLoading;
  setLocale: SetLocale;
  hidePopup: HidePopup;
  getCommonTranslation: GetCommonTranslation;
}

export interface IAppStoreProps extends IWithUserStoreProps {
  ui: IUIState;
  locale: string;
  userType?: AccountType;
  isLoading: boolean;
  isCommonTranslationLoaded: boolean;
  userId?: string;
  additionalInfo: IUser;
}

export interface IAppProps extends IAppStoreProps, IAppActions, RouterProps {}

export const App: React.FC<IAppProps> = ({ router }) => {
  useSupportChat(router.location.pathname, undefined, config.supportChatBotId);

  return (
    <>
      <UniversalAppShell
        serviceBannerPortalNone={<div id={SMART_BANNER_CONTAINER_ID} />}
      >
        <Outlet />
      </UniversalAppShell>
      <Popups />
    </>
  );
};

const mapDispatchToProps: MapDispatchToProps<IAppActions> = {
  setLoading,
  setLocale,
  hidePopup,
  getCommonTranslation,
  getUserData,
};

const mapStateToProps = (state: IApplicationState): IAppStoreProps => ({
  ui: state.ui,
  locale: state.ui.locale,
  isLoading: state.ui.isLoading,
  isCommonTranslationLoaded: state.translation.isCommonLoaded,
  isUserLoaded: state.user.isLoaded,
  userType: state.user.data?.type,
  userId: state.user.data?.id,
  additionalInfo: state.user.data!,
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withGlobalSpinner,
  withUserData,
  withLocalizedData,
  withAccessControl({
    accountTypes: [AccountType.Performer, AccountType.Agent],
  })
)(App) as React.ComponentType;
